import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import isNil from 'lodash/isNil';
import { selectColorSchemePreference } from 'reducers/selectors';
import Modal from 'utils/packages/Modal';
import Text from 'design-system/Text';
import { BadgeBase, rem, SettingsItem } from 'design-system';
import { IconContrast, IconSun, IconMoon, IconSuccess, } from 'design-system/icons';
import { setUserColorScheme } from 'actions';
import { SettingsItemIcon } from 'design-system/SettingsItemIcon';
import { useAppDispatch, useAppSelector } from 'store/hooks';
const strings = {
    title: 'Appearance',
    system: {
        title: 'System',
        description: 'Using default system settings',
    },
    dark: {
        title: 'Dark',
    },
    light: {
        title: 'Light',
    },
};
const switchModesMap = {
    dark: 'dark',
    light: 'light',
    system: undefined,
};
export const AppearanceModal = {
    show: (colors) => {
        Modal.show(<AppearanceContent />, {
            containerStyle: {
                ...styles.modal,
                backgroundColor: colors.cards.onDark,
            },
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const IconWrapper = ({ children, checked, }) => (<View style={styles.icon}>
    <SettingsItemIcon>{children}</SettingsItemIcon>
    {checked ? (<BadgeBase>
        <IconSuccess />
      </BadgeBase>) : null}
  </View>);
const AppearanceContent = () => {
    const userColorScheme = useAppSelector(selectColorSchemePreference);
    const dispatch = useAppDispatch();
    const handlePress = useCallback((key) => {
        Modal.hide(() => {
            // app.tsx applies the preference with Appearance.setColorScheme
            dispatch(setUserColorScheme(switchModesMap[key]));
        });
    }, [dispatch]);
    return (<>
      <View style={styles.textContainer}>
        <Text Text-20 centered>
          {strings.title}
        </Text>
      </View>
      <SettingsItem title={strings.system.title} description={strings.system.description} renderIcon={() => (<IconWrapper checked={isNil(userColorScheme)}>
            <IconContrast />
          </IconWrapper>)} onPress={() => handlePress('system')}/>
      <SettingsItem title={strings.dark.title} renderIcon={() => (<IconWrapper checked={userColorScheme === 'dark'}>
            <IconMoon />
          </IconWrapper>)} onPress={() => handlePress('dark')}/>
      <SettingsItem title={strings.light.title} renderIcon={() => (<IconWrapper checked={userColorScheme === 'light'}>
            <IconSun />
          </IconWrapper>)} onPress={() => handlePress('light')}/>
    </>);
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        paddingTop: rem(40),
    },
    icon: {
        marginRight: rem(16),
    },
    textContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: rem(8),
        maxWidth: rem(240),
        alignSelf: 'center',
    },
});
export default AppearanceContent;
